import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getAppWithMedia, getAppsWithMedia, resetAppsWithMedia, getApps } from '../../reducers/create-app/duck';
import { uploadMedia, deleteMedia } from '../../reducers/media/duck';
import { attachMedia, getAppCampaigns, resetCampaignStore } from '../../reducers/create-campaign/duck';
import MediaLibraryScreen from './MediaLibraryScreen';

const mapStateToProps =
({
  createAppStore: {
    currentAppFullMedias, apps, hasMoreApps, getAppsStatus, pageApps, appsFullMedias,
    appsFullMediasStatus,
    pageAppsFullMedias,
    hasMoreAppsFullMedias,
    getAppMediaStatus,

  },
  mediaStore: {
    uploadMediaStatus,
  },
  campaignStore: {
    attachMediaStatus, attachMediaError, currentAppCampaigns,
  },
  userStore: {
    sidebarStatus,
  },
}) => ({
  currentAppFullMedias,
  uploadMediaStatus,
  attachMediaStatus,
  attachMediaError,
  appsFullMedias,
  appsFullMediasStatus,
  pageAppsFullMedias,
  hasMoreAppsFullMedias,
  apps,
  hasMoreApps,
  getAppsStatus,
  pageApps,
  currentAppCampaigns,
  getAppMediaStatus,
  sidebarStatus,
});

const mapDispatchToProps = {
  getAppWithMedia,
  uploadMedia,
  deleteMedia,
  attachMedia,
  getAppsWithMedia,
  resetAppsWithMedia,
  getApps,
  getAppCampaigns,
  resetCampaignStore,
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,

)(MediaLibraryScreen));



// WEBPACK FOOTER //
// ./src/containers/MediaLibraryScreen/index.js